export const config = {
    'Stelvio Quadrifoglio': {
        "displayname": "Stelvio Quadrifoglio",
        "carsize": "Mid-Size",
        url: "https://assets.fcaab.com.au/assets-public/forms/alfa/Stelvio-Q.jpg",
        alt: "Stelvio Quadrifoglio",
        cta: {
            "features": "https://www.alfaromeo.com.au/stelvio-quadrifoglio.html",
            "offers": "https://www.alfaromeo.com.au/offers/offers-stelvio.html",
            "testdrive": "https://www.alfaromeo.com.au/request-a-test-drive.html?vehicle=STELVIO-QUADRIFOGLIO&year=2018",
            "brochure": "https://www.alfaromeo.com.au/request-a-brochure.html?vehicle=STELVIO-QUADRIFOGLIO&year=2018",
            "quote": "https://www.alfaromeo.com.au/request-a-quote.html?vehicle=STELVIO-QUADRIFOGLIO&year=2018",
            "specs": "https://www.alfaromeo.com.au/content/dam/cross-regional/apac/alfaromeo/en_au/request-a-brochure/pdfs/STELVIOQ_Web-v1.pdf"
        },
        "year": "2018", images: [
            "https://assets.fcaab.com.au/assets-public/forms/alfa/1x/mobile/portrait/Stelvio-Q.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/alfa/2x/mobile/portrait/Stelvio-Q.jpg 2x",
            "https://assets.fcaab.com.au/assets-public/forms/alfa/1x/mobile/landscape/Stelvio-Q.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/alfa/2x/mobile/landscape/Stelvio-Q.jpg 2x",
            "https://assets.fcaab.com.au/assets-public/forms/alfa/1x/tablet/landscape/Stelvio-Q.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/alfa/2x/tablet/landscape/Stelvio-Q.jpg 2x",
            "https://assets.fcaab.com.au/assets-public/forms/alfa/1x/tablet/portrait/Stelvio-Q.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/alfa/2x/tablet/portrait/Stelvio-Q.jpg 2x",
            "https://assets.fcaab.com.au/assets-public/forms/alfa/1x/desktop/Stelvio-Q.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/alfa/2x/desktop/Stelvio-Q.jpg 2x"

        ]

    },
    "Stelvio": {
        "displayname": "Stelvio",
        "carsize": "Small SUV",
        url: "https://assets.fcaab.com.au/assets-public/forms/alfa/Stelvio.jpg",
        alt: "Stelvio",
        cta: {
            "features": "https://www.alfaromeo.com.au/stelvio.html",
            "offers": "https://www.alfaromeo.com.au/offers/offers-stelvio.html",
            "testdrive": "https://www.alfaromeo.com.au/request-a-test-drive.html?vehicle=STELVIO&year=2018",
            "brochure": "https://www.alfaromeo.com.au/request-a-brochure.html?vehicle=STELVIO&year=2018",
            "quote": "https://www.alfaromeo.com.au/request-a-quote.html?vehicle=STELVIO&year=2018",
            "specs": "https://www.alfaromeo.com.au/content/dam/cross-regional/apac/alfaromeo/en_au/formimages/Stelvio_S0_Catalog_AUS_WEB.pdf",
        },
        "year": "2018",
        images: ["https://assets.fcaab.com.au/assets-public/forms/alfa/1x/mobile/portrait/Stelvio.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/alfa/2x/mobile/portrait/Stelvio.jpg 2x",
            "https://assets.fcaab.com.au/assets-public/forms/alfa/1x/mobile/landscape/Stelvio.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/alfa/2x/mobile/landscape/Stelvio.jpg 2x",
            "https://assets.fcaab.com.au/assets-public/forms/alfa/1x/tablet/landscape/Stelvio.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/alfa/2x/tablet/landscape/Stelvio.jpg 2x",
            "https://assets.fcaab.com.au/assets-public/forms/alfa/1x/tablet/portrait/Stelvio.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/alfa/2x/tablet/portrait/Stelvio.jpg 2x",
            "https://assets.fcaab.com.au/assets-public/forms/alfa/1x/desktop/Stelvio.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/alfa/2x/desktop/Stelvio.jpg 2x"
        ]
    },
    'Giulia Quadrifoglio': {
        "displayname": "Giulia Quadrifoglio",
        "carsize": "Sedan",
        url: "https://assets.fcaab.com.au/assets-public/forms/alfa/Giulia-Q.jpg",
        alt: "Giulia Quadrifoglio",
        cta: {
            "features": "https://www.alfaromeo.com.au/giulia-quadrifoglio.html",
            "offers": "https://www.alfaromeo.com.au/offers/offers-giulia.html",
            "testdrive": "https://www.alfaromeo.com.au/request-a-test-drive.html?vehicle=GIULIA-QUADRIFOGLIO&year=2017",
            "brochure": "https://www.alfaromeo.com.au/request-a-brochure.html?vehicle=GIULIA-QUADRIFOGLIO&year=2017",
            "quote": "https://www.alfaromeo.com.au/request-a-quote.html?vehicle=GIULIA-QUADRIFOGLIO&year=2017",
            "specs": "https://www.alfaromeo.com.au/content/dam/cross-regional/apac/alfaromeo/en_au/request-a-brochure/pdfs/Giulia_Quadrifoglio_Brochure.pdf"
        },
        "year": "2017",
        images: ["https://assets.fcaab.com.au/assets-public/forms/alfa/1x/mobile/portrait/Giulia-Q.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/alfa/2x/mobile/portrait/Giulia-Q.jpg 2x",
            "https://assets.fcaab.com.au/assets-public/forms/alfa/1x/mobile/landscape/Giulia-Q.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/alfa/2x/mobile/landscape/Giulia-Q.jpg 2x",
            "https://assets.fcaab.com.au/assets-public/forms/alfa/1x/tablet/landscape/Giulia-Q.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/alfa/2x/tablet/landscape/Giulia-Q.jpg 2x",
            "https://assets.fcaab.com.au/assets-public/forms/alfa/1x/tablet/portrait/Giulia-Q.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/alfa/2x/tablet/portrait/Giulia-Q.jpg 2x",
            "https://assets.fcaab.com.au/assets-public/forms/alfa/1x/desktop/Giulia-Q.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/alfa/2x/desktop/Giulia-Q.jpg 2x"
        ]
    },
    "Giulia": {
        "displayname": "Giulia",
        "carsize": "Sedan",
        url: "https://assets.fcaab.com.au/assets-public/forms/alfa/Giulia.jpg",
        alt: "Giulia",
        cta: {
            "features": "https://www.alfaromeo.com.au/giulia.html",
            "offers": "https://www.alfaromeo.com.au/offers/offers-giulia.html",
            "testdrive": "https://www.alfaromeo.com.au/request-a-test-drive.html?vehicle=GIULIA&year=2017",
            "brochure": "https://www.alfaromeo.com.au/request-a-brochure.html?vehicle=GIULIA&year=2017",
            "quote": "https://www.alfaromeo.com.au/request-a-quote.html?vehicle=GIULIA&year=2017",
            "specs": "https://www.alfaromeo.com.au/content/dam/cross-regional/apac/alfaromeo/en_au/request-a-brochure/pdfs/Giulia Brochure.pdf",

        },
        "year": "2017",
        images: ["https://assets.fcaab.com.au/assets-public/forms/alfa/1x/mobile/portrait/Giulia.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/alfa/2x/mobile/portrait/Giulia.jpg 2x",
            "https://assets.fcaab.com.au/assets-public/forms/alfa/1x/mobile/landscape/Giulia.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/alfa/2x/mobile/landscape/Giulia.jpg 2x",
            "https://assets.fcaab.com.au/assets-public/forms/alfa/1x/tablet/landscape/Giulia.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/alfa/2x/tablet/landscape/Giulia.jpg 2x",
            "https://assets.fcaab.com.au/assets-public/forms/alfa/1x/tablet/portrait/Giulia.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/alfa/2x/tablet/portrait/Giulia.jpg 2x",
            "https://assets.fcaab.com.au/assets-public/forms/alfa/1x/desktop/Giulia.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/alfa/2x/desktop/Giulia.jpg 2x"
        ]
    },
    "Giulietta": {
        "displayname": "Giulietta",
        "carsize": "Small Car",
        url: "https://assets.fcaab.com.au/assets-public/forms/alfa/Giulietta.jpg",
        alt: "Giulietta",
        cta: {
            "features": "https://www.alfaromeo.com.au/giulietta.html",
            "offers": "https://www.alfaromeo.com.au/offers/offers-giulietta.html",
            "testdrive": "https://www.alfaromeo.com.au/request-a-test-drive.html?vehicle=GIULIETTA&year=2017",
            "brochure": "https://www.alfaromeo.com.au/request-a-brochure.html?vehicle=GIULIETTA&year=2017",
            "quote": "https://www.alfaromeo.com.au/request-a-quote.html?vehicle=GIULIETTA&year=2017",
            "specs": "https://www.alfaromeo.com.au/content/dam/cross-regional/apac/alfaromeo/en_au/pdf/Giulietta_S3_Brochure_V2.pdf"

        },
        "year": "2017",
        images: ["https://assets.fcaab.com.au/assets-public/forms/alfa/1x/mobile/portrait/Giulietta.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/alfa/2x/mobile/portrait/Giulietta.jpg 2x",
            "https://assets.fcaab.com.au/assets-public/forms/alfa/1x/mobile/landscape/Giulietta.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/alfa/2x/mobile/landscape/Giulietta.jpg 2x",
            "https://assets.fcaab.com.au/assets-public/forms/alfa/1x/tablet/landscape/Giulietta.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/alfa/2x/tablet/landscape/Giulietta.jpg 2x",
            "https://assets.fcaab.com.au/assets-public/forms/alfa/1x/tablet/portrait/Giulietta.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/alfa/2x/tablet/portrait/Giulietta.jpg 2x",
            "https://assets.fcaab.com.au/assets-public/forms/alfa/1x/desktop/Giulietta.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/alfa/2x/desktop/Giulietta.jpg 2x"
        ]
    },
    '4C Coupe': {
        "displayname": "4C Coupe",
        "carsize": "Coupe",
        url: "https://assets.fcaab.com.au/assets-public/forms/alfa/4C-Coupe.jpg",
        alt: "4C Coupe",
        cta: {
            "features": "https://www.alfaromeo.com.au/alfa-4c.html",
            "offers": "https://www.alfaromeo.com.au/offers.html",
            "testdrive": "https://www.alfaromeo.com.au/request-a-test-drive.html?vehicle=4C-COUPE&year=2017",
            "brochure": "https://www.alfaromeo.com.au/request-a-brochure.html?vehicle=4C-COUPE&year=2017",
            "quote": "https://www.alfaromeo.com.au/request-a-quote.html?vehicle=4C-COUPE&year=2017",
            "specs": "https://www.alfaromeo.com.au/content/dam/cross-regional/apac/alfaromeo/en_au/request-a-brochure/pdfs/4C_Coupe Brochure.pdf"
        },
        "year": "2018",
        images: ["https://assets.fcaab.com.au/assets-public/forms/alfa/1x/mobile/portrait/4C-Coupe.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/alfa/2x/mobile/portrait/4C-Coupe.jpg 2x",
            "https://assets.fcaab.com.au/assets-public/forms/alfa/1x/mobile/landscape/4C-Coupe.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/alfa/2x/mobile/landscape/4C-Coupe.jpg 2x",
            "https://assets.fcaab.com.au/assets-public/forms/alfa/1x/tablet/landscape/4C-Coupe.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/alfa/2x/tablet/landscape/4C-Coupe.jpg 2x",
            "https://assets.fcaab.com.au/assets-public/forms/alfa/1x/tablet/portrait/4C-Coupe.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/alfa/2x/tablet/portrait/4C-Coupe.jpg 2x",
            "https://assets.fcaab.com.au/assets-public/forms/alfa/1x/desktop/4C-Coupe.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/alfa/2x/desktop/4C-Coupe.jpg 2x"
        ]
    },
    '4C Spider': {
        "displayname": "4C Spider",
        "carsize": "Sports",
        url: "https://assets.fcaab.com.au/assets-public/forms/alfa/4C-Spider.jpg",
        alt: "4C Spider",
        cta: {
            "features": "https://www.alfaromeo.com.au/alfa-4c-spider.html",
            "offers": "https://www.alfaromeo.com.au/offers.html",
            "testdrive": "https://www.alfaromeo.com.au/request-a-test-drive.html?vehicle=4C-SPIDER&year=2017",
            "brochure": "https://www.alfaromeo.com.au/request-a-brochure.html?vehicle=4C-SPIDER&year=2017",
            "quote": "https://www.alfaromeo.com.au/request-a-quote.html?vehicle=4C-SPIDER&year=2017",
            "specs": "https://www.alfaromeo.com.au/content/dam/cross-regional/apac/alfaromeo/en_au/request-a-brochure/pdfs/4C_Spider Brochure.pdf"
        },
        "year": "2018",
        images: ["https://assets.fcaab.com.au/assets-public/forms/alfa/1x/mobile/portrait/4C-Spider.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/alfa/2x/mobile/portrait/4C-Spider.jpg 2x",
            "https://assets.fcaab.com.au/assets-public/forms/alfa/1x/mobile/landscape/4C-Spider.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/alfa/2x/mobile/landscape/4C-Spider.jpg 2x",
            "https://assets.fcaab.com.au/assets-public/forms/alfa/1x/tablet/landscape/4C-Spider.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/alfa/2x/tablet/landscape/4C-Spider.jpg 2x",
            "https://assets.fcaab.com.au/assets-public/forms/alfa/1x/tablet/portrait/4C-Spider.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/alfa/2x/tablet/portrait/4C-Spider.jpg 2x",
            "https://assets.fcaab.com.au/assets-public/forms/alfa/1x/desktop/4C-Spider.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/alfa/2x/desktop/4C-Spider.jpg 2x"
        ]
    },
    "Nring" : {
        "displayname" : "NRING",
        "url" : "",
        "alt" : "" ,
        "cta" : {
            "features": "",
            "offers": "",
            "brochure": "",
            "quote" : "",
            "testdrive": "",
            "specs" : "",
        },
        "year" : "2019",
        "images" : [

        ]
    },
    "Tonale Phev" : {
        "displayname" : "Tonale PHEV",
        "url" : "https://assets.fcaab.com.au/assets-public/forms/alfa/Tonale.jpg",
        "alt" : "Tonale" ,
        "cta" : {
            "features": "https://www.alfaromeo.com.au/tonale.html",
            "offers": "https://www.alfaromeo.com.au/offers.html",
            "brochure": "https://www.alfaromeo.com.au/request-a-brochure.html?vehicle=Tonale",
            "quote" : "https://www.alfaromeo.com.au/request-a-quote.html?vehicle=Tonale",
            "testdrive": "https://www.alfaromeo.com.au/request-a-test-drive.html?vehicle=Tonale",
            "specs" : "https://www.alfaromeo.com.au/tonale.html",
        },
        "year" : "2022",
        images: ["https://assets.fcaab.com.au/assets-public/forms/alfa/1x/mobile/portrait/TonalePHEV.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/alfa/2x/mobile/portrait/TonalePHEV.jpg 2x",
            "https://assets.fcaab.com.au/assets-public/forms/alfa/1x/mobile/landscape/TonalePHEV.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/alfa/2x/mobile/landscape/TonalePHEV.jpg 2x",
            "https://assets.fcaab.com.au/assets-public/forms/alfa/1x/tablet/landscape/TonalePHEV.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/alfa/2x/tablet/landscape/TonalePHEV.jpg 2x",
            "https://assets.fcaab.com.au/assets-public/forms/alfa/1x/tablet/portrait/TonalePHEV.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/alfa/2x/tablet/portrait/TonalePHEV.jpg 2x",
            "https://assets.fcaab.com.au/assets-public/forms/alfa/1x/desktop/TonalePHEV.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/alfa/2x/desktop/TonalePHEV.jpg 2x"
        ]
    },
    "Tonale" : {
        "displayname" : "Tonale",
        "url" : "https://assets.fcaab.com.au/assets-public/forms/alfa/Tonale.jpg",
        "alt" : "Tonale" ,
        "cta" : {
            "features": "https://www.alfaromeo.com.au/tonale.html",
            "offers": "https://www.alfaromeo.com.au/offers.html",
            "brochure": "https://www.alfaromeo.com.au/request-a-brochure.html?vehicle=Tonale",
            "quote" : "https://www.alfaromeo.com.au/request-a-quote.html?vehicle=Tonale",
            "testdrive": "https://www.alfaromeo.com.au/request-a-test-drive.html?vehicle=Tonale",
            "specs" : "https://www.alfaromeo.com.au/tonale.html",
        },
        "year" : "2022",
        images: ["https://assets.fcaab.com.au/assets-public/forms/alfa/1x/mobile/portrait/Tonale.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/alfa/2x/mobile/portrait/Tonale.jpg 2x",
            "https://assets.fcaab.com.au/assets-public/forms/alfa/1x/mobile/landscape/Tonale.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/alfa/2x/mobile/landscape/Tonale.jpg 2x",
            "https://assets.fcaab.com.au/assets-public/forms/alfa/1x/tablet/landscape/Tonale.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/alfa/2x/tablet/landscape/Tonale.jpg 2x",
            "https://assets.fcaab.com.au/assets-public/forms/alfa/1x/tablet/portrait/Tonale.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/alfa/2x/tablet/portrait/Tonale.jpg 2x",
            "https://assets.fcaab.com.au/assets-public/forms/alfa/1x/desktop/Tonale.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/alfa/2x/desktop/Tonale.jpg 2x"
        ]
    },
    "Milano" : {
        "displayname" : "Milano",
        "url" : "https://assets.fcaab.com.au/assets-public/forms/alfa/Milano.jpg",
        "alt" : "Milano" ,
        "cta" : {
            "features": "https://www.alfaromeo.com.au/milano.html",
            "offers": "https://www.alfaromeo.com.au/offers.html",
            "brochure": "https://www.alfaromeo.com.au/request-a-brochure.html?vehicle=Milano",
            "quote" : "https://www.alfaromeo.com.au/request-a-quote.html?vehicle=Milano",
            "testdrive": "https://www.alfaromeo.com.au/request-a-test-drive.html?vehicle=Milano",
            "specs" : "https://www.alfaromeo.com.au/milano.html",
        },
        "year" : "2022",
        images: ["https://assets.fcaab.com.au/assets-public/forms/alfa/1x/mobile/portrait/Milano.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/alfa/2x/mobile/portrait/Milano.jpg 2x",
            "https://assets.fcaab.com.au/assets-public/forms/alfa/1x/mobile/landscape/Milano.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/alfa/2x/mobile/landscape/Milano.jpg 2x",
            "https://assets.fcaab.com.au/assets-public/forms/alfa/1x/tablet/landscape/Milano.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/alfa/2x/tablet/landscape/Milano.jpg 2x",
            "https://assets.fcaab.com.au/assets-public/forms/alfa/1x/tablet/portrait/Milano.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/alfa/2x/tablet/portrait/Milano.jpg 2x",
            "https://assets.fcaab.com.au/assets-public/forms/alfa/1x/desktop/Milano.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/alfa/2x/desktop/Milano.jpg 2x"
        ]
    },
    "Junior" : {
        "displayname" : "Junior",
        "url" : "https://assets.fcaab.com.au/assets-public/forms/alfa/Junior.jpg",
        "alt" : "Junior" ,
        "cta" : {
            "features": "https://www.alfaromeo.com.au/junior.html",
            "offers": "https://www.alfaromeo.com.au/offers.html",
            "brochure": "https://www.alfaromeo.com.au/request-a-brochure.html?vehicle=Junior",
            "quote" : "https://www.alfaromeo.com.au/request-a-quote.html?vehicle=Junior",
            "testdrive": "https://www.alfaromeo.com.au/request-a-test-drive.html?vehicle=Junior",
            "specs" : "https://www.alfaromeo.com.au/junior.html",
        },
        "year" : "2022",
        images: ["https://assets.fcaab.com.au/assets-public/forms/alfa/1x/mobile/portrait/Milano.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/alfa/2x/mobile/portrait/Milano.jpg 2x",
            "https://assets.fcaab.com.au/assets-public/forms/alfa/1x/mobile/landscape/Milano.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/alfa/2x/mobile/landscape/Milano.jpg 2x",
            "https://assets.fcaab.com.au/assets-public/forms/alfa/1x/tablet/landscape/Milano.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/alfa/2x/tablet/landscape/Milano.jpg 2x",
            "https://assets.fcaab.com.au/assets-public/forms/alfa/1x/tablet/portrait/Milano.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/alfa/2x/tablet/portrait/Milano.jpg 2x",
            "https://assets.fcaab.com.au/assets-public/forms/alfa/1x/desktop/Milano.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/alfa/2x/desktop/Milano.jpg 2x"
        ]
    },
    models: [
        'Tonale',
        'Tonale Phev',
        'Stelvio Quadrifoglio',
        'Stelvio',
        'Giulia Quadrifoglio',
        'Giulia',
        'Milano',
        'Junior',
    ],
    privacypolicy : "https://www.alfaromeo.com.au/privacypolicy.html",
    ra : "https://www.alfaromeo.com.au/roadside-assistance.html",
    "compPrivacypolicy" : "https://www.alfaromeo.com.au/privacypolicy.html",
    brochureSentByEmail: true,
    virtualtestdrivedealers:  [


        {name: "Barbagallo Alfa Romeo" , email : "barbagallofiatalfaromeo@gmail.com" , suburb : "Perth" , postcode : "6017"},
        {name: "Brighton Alfa Romeo" , email : "brightonfiatalfaromeo@gmail.com" , suburb : "Brighton" , postcode : "3204"},
        {name: "FR Ireland Alfa Romeo" , email : "frirelandfiatalfaromeo@gmail.com" , suburb : "Cairns" , postcode : "4870"},
        {name: "Gulson Alfa Romeo" , email : "gulsonfiatalfaromeo@gmail.com" , suburb : "Canberra" , postcode : "2609"},
        {name: "Hobart Alfa Romeo" , email : "hobartalfaromeo@gmail.com" , suburb : "Hobart" , postcode : "7000"},
        {name: "McCarroll's Alfa Romeo - Artarmon" , email : "mccarrollsfiatalfaromeo@gmail.com" , suburb : "Artarmon" , postcode : "2064"},
        {name: "Nunawading Alfa Romeo" , email : "nunawadingfiatalfaromeo@gmail.com" , suburb : "Nunawading" , postcode : "3131"},
        {name: "Parramatta Alfa Romeo" , email : "parramattafiatalfaromeo@gmail.com" , suburb : "Parramatta" , postcode : "2141"},
        {name: "Solitaire Alfa Romeo" , email : "solitairefiatalfaromeo@gmail.com" , suburb : "Adelaide" , postcode : "5063"},
        {name: "Southern Classic Alfa Romeo" , email : "southernclassicfiatalfaromeo@gmail.com" , suburb : "Wollongong" , postcode : "2500"},
        {name: "Sunshine Coast Alfa Romeo" , email : "sunshinecoastfiatalfaromeo@gmail.com" , suburb : "Sunshine Coast" , postcode : "4566"},
        {name: "Zagame Alfa Romeo" , email : "zagamefiatalfaromeo@gmail.com" , suburb : "Richmond" , postcode : "3121"},
    ],

};
